export const searchInputClassName = 'automation-rules-search-input';
